import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message, Modal } from '@/components';
import { RootStore, chat, transcribe } from '@/models';
import styles from './index.less';
import classNames from 'classnames';
import HandupCount from '../../../HandupCount';
import ActionBtn from '../../H5/ActionBtn';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'user' | 'meeting'>> {
  RTCInstance?: RootStore['rtc'];
  user?: RootStore['user'];
  meeting?: RootStore['meeting'];
}
const Member: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    user: store.user,
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { RTCInstance, user, meeting } = props;
    const { formatMessage } = useIntl();

    const openMember = () => {
      if (RTCInstance?.breakLineReconnecting) {
        return;
      }
      meeting?.setPeoplePanelShow(!meeting?.peoplePanelShow);
      chat?.setChatVisible(false);
      transcribe?.setTranscribeVisible(false);
    };

    return (
      <ActionBtn
        bottomTitle={formatMessage({ id: 'MEMBER_MANAGEMENT' })}
        className={classNames(styles.MemberBtn, {
          [styles.disable]: RTCInstance?.breakLineReconnecting,
        })}
        onClick={openMember}
      >
        <Icon className={styles.icon} name="icon-contact" size={24} />
      </ActionBtn>
    );
  })
);

export default Member;
